import { type CharacterPortrait, lookTints } from '@shefira/shared';

import type { DomAtlas } from '../assets/dom-atlas.js';
import { DollPreview } from './doll-preview.js';

/** The head in the 32 px frame: what the HUD's profile button and the party frames show. */
export const HEAD_FRAME = { x: 8, y: 0, size: 16 };

/**
 * A player's head, dressed as the zone shows them (helmet included), drawn
 * from the same frames as the game onto a small canvas. The canvas is
 * `HEAD_FRAME.size` pixels; CSS scales it up without smoothing.
 */
export function headPortrait(atlas: DomAtlas, portrait: CharacterPortrait): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = HEAD_FRAME.size;
  canvas.height = HEAD_FRAME.size;
  const prefix = atlas.prefixOf(`body.${portrait.classId}`);
  const context = canvas.getContext('2d');
  if (prefix === null || context === null) return canvas;
  const doll = new DollPreview({
    bodyKey: prefix,
    frame: atlas.frame,
    featureTints: lookTints(portrait.look),
    hairStyle: portrait.look.hairStyle,
    body: portrait.look.body,
    scale: 1,
  });
  // The summary carries template ids; the preview wants instances.
  doll.draw(
    Object.fromEntries(
      Object.entries(portrait.appearance).map(([slot, templateId]) => [
        slot,
        { id: slot, templateId, quantity: 1, upgradeLevel: 0, bound: false },
      ]),
    ),
  );
  context.imageSmoothingEnabled = false;
  context.drawImage(
    doll.canvas,
    HEAD_FRAME.x,
    HEAD_FRAME.y,
    HEAD_FRAME.size,
    HEAD_FRAME.size,
    0,
    0,
    HEAD_FRAME.size,
    HEAD_FRAME.size,
  );
  return canvas;
}
